import React, { FC } from 'react';
import { useAuth } from 'global/auth/use-auth';
import { RoutesSettings } from 'config/routes';
import { Navigate } from 'react-router-dom';
import { Loading } from 'common/loading';

export const PrivateRoute: FC<any> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  return isLoading ? <Loading /> : isAuthenticated ? children : <Navigate replace to={RoutesSettings.signIn} />;
};
